import { render, staticRenderFns } from "./ModificarExamenes.vue?vue&type=template&id=7d374470&scoped=true&"
import script from "./ModificarExamenes.vue?vue&type=script&lang=js&"
export * from "./ModificarExamenes.vue?vue&type=script&lang=js&"
import style0 from "./ModificarExamenes.vue?vue&type=style&index=0&id=7d374470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d374470",
  null
  
)

export default component.exports